// src/js/components/hoverTooltip.js

export function initializeHoverTooltips() {
    const tooltips = document.querySelectorAll('.tooltip');
    if (tooltips.length === 0) return;

    // Variabel för att hålla reda på den nuvarande aktiva tooltipen
    let activeTooltip = null;

    tooltips.forEach(tooltip => {
        const trigger = tooltip.querySelector('.tooltip__trigger');
        const box = tooltip.querySelector('.tooltip__box');
        let hideTimeout;

        if (!trigger || !box) return;

        const show = () => {
            // Om en annan tooltip redan är aktiv, stäng den omedelbart
            if (activeTooltip && activeTooltip !== tooltip) {
                activeTooltip.classList.remove('is-visible');
            }
            
            clearTimeout(hideTimeout);
            tooltip.classList.add('is-visible');
            activeTooltip = tooltip; // Sätt den nuvarande som aktiv
        };

        const hide = (event) => {
            // "DEBUG MODE": Om Shift-tangenten hålls nere, avbryt stängningen
            if (event && event.shiftKey) {
                console.log('DEBUG: Tooltip pinned with Shift key.');
                return;
            }

            hideTimeout = setTimeout(() => {
                tooltip.classList.remove('is-visible');
                if (activeTooltip === tooltip) {
                    activeTooltip = null;
                }
            }, 200);
        };

        // Uppdatera lyssnarna för att skicka med event-objektet till hide-funktionen
        trigger.addEventListener('mouseenter', show);
        box.addEventListener('mouseenter', show);
        trigger.addEventListener('mouseleave', (e) => hide(e));
        box.addEventListener('mouseleave', (e) => hide(e));
    });
    
    console.log('Hover Tooltips Initialized (with close-others and debug-pinning).');
}